import React from "react";

// CT-e cancelado na SEFAZ que não pôde ser removido do Hub (PO1-3071, épico
// PO1-2251). Mesmo span de status das telas de auditoria/conferência, com os
// tokens --everlog-status-danger/-bg/-border: não é uma variante nova de badge.
// Texto fixo, sem data e sem protocolo (decisão do Rodrigo, 12/09/2026).
export const CANCELADO_SEFAZ_LABEL = "Cancelado na SEFAZ";
export const CANCELADO_SEFAZ_TITLE =
  "A SEFAZ registrou o cancelamento deste CT-e, mas ele não pôde ser removido do Hub porque está vinculado a fatura. Marque NOK na conferência para o cancelamento entrar no próximo ciclo.";

export function isCanceladoSefaz(item) {
  if (!item) return false;
  const v = item.canceladoSefaz;
  return v === true || Number(v) === 1;
}

export default function CanceladoSefazBadge({ compact = false, style, title }) {
  return (
    <span
      title={title || CANCELADO_SEFAZ_TITLE}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 999,
        padding: compact ? "0.18rem 0.55rem" : "0.35rem 0.7rem",
        fontSize: compact ? "0.71rem" : "0.74rem",
        fontWeight: 700,
        color: "var(--everlog-status-danger)",
        background: "var(--everlog-status-danger-bg)",
        border: "1px solid var(--everlog-status-danger-border)",
        whiteSpace: "nowrap",
        cursor: "help",
        ...(style || {}),
      }}
    >
      {CANCELADO_SEFAZ_LABEL}
    </span>
  );
}
